// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__5W-03","modalBody":"MealsPop_modalBody__cl+nH"};